import React from 'react';
import Icon from '../../../components/dashboard/DashboardIcons';

export default function ExpiringAlert({ count, onClick }) {
  if (!count) return null;
  return (
    <button
      onClick={onClick}
      className="flex w-full items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-right text-sm text-amber-800 hover:bg-amber-100"
      data-testid="subs-alert"
    >
      <Icon name="warning" className="w-4 h-4 shrink-0" />
      <span className="min-w-0 truncate">{count} اشتراك{count > 1 ? 'ات' : ''} تنتهي خلال 7 أيام — عرض اللاعبين</span>
    </button>
  );
}
